// Story 10.2 — Hook tipado para `GET /api/v1/bots/:id/stats`.
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { StatsSince } from '@/lib/stats-types';

export interface BotStats {
  conversations: number;
  messagesReceived: number;
  messagesSent: number;
  flowsCompleted: number;
  flowErrors: number;
  partial: boolean;
}

export function useBotStats(botId: number, since: StatsSince = 'today') {
  return useQuery({
    queryKey: ['bots', botId, 'stats', since] as const,
    queryFn: () => api.get<BotStats>(`/api/v1/bots/${botId}/stats?since=${since}`),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    enabled: Number.isFinite(botId),
  });
}
